// StudyAbroadPage.js
import React from 'react';
import StudyAbroadHero from '../components/StudyAbroad/StudyAbroadHero';
import StudyAbroadIntro from '../components/StudyAbroad/StudyAbroadIntro';
import TargetAudience from '../components/StudyAbroad/TargetAudience';
import SupportServices from '../components/StudyAbroad/SupportServices';
import AcademicPartnerships from '../components/StudyAbroad/AcademicPartnerships';
import ProcessSteps from '../components/StudyAbroad/ProcessSteps';
import FAQSection from '../components/StudyAbroad/FAQSection';
import CTASection from '../components/StudyAbroad/CTASection';

const StudyAbroadPage = () => {
  return (
    <div>
      <StudyAbroadHero />
      <StudyAbroadIntro />
      <TargetAudience />
      <SupportServices />
      <AcademicPartnerships />
      <ProcessSteps />
      <FAQSection />
      <CTASection />
    </div>
  );
};

export default StudyAbroadPage;
